export const SIDEBAR_NAVIGATION_SX_MARGIN_X = 1.5;
export const SIDEBAR_NAVIGATION_DRAWER_WIDTH = 228;
export const SIDEBAR_NAVIGATION_COLLAPSED_WIDTH = 52;
